import IconPause from 'approot/shared/icons/icon-pause';
import IconPlay from 'approot/shared/icons/icon-play';
import { TTSPlayPause } from '../tts.style';

type Props = {
  isAudioPlaying: boolean;
  isAudioPaused: boolean;
  onClick: () => void;
};

const TTSPlayPauseButton = ({
  isAudioPlaying,
  isAudioPaused,
  onClick,
}: Props) => {
  return (
    <TTSPlayPause
      type="button"
      data-tts="true"
      $isPlay={isAudioPlaying}
      onClick={onClick}
    >
      {isAudioPlaying ? (
        <>
          <IconPause width={20} height={20} />
          <span>Pause</span>
        </>
      ) : isAudioPaused ? (
        <>
          <IconPlay width={20} height={20} />
          <span>Resume</span>
        </>
      ) : (
        <>
          <IconPlay width={20} height={20} />
          <span>Play</span>
        </>
      )}
    </TTSPlayPause>
  );
};

export default TTSPlayPauseButton;
